// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatLegend--StatLegend--AEcS9 {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.StatLegend--StatLegendItemWrapper--EFDg1 {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0 1em 0 0;
  gap: .2em;
}

.StatLegend--StatLegendItem--vpFW6 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.StatLegend--StatLegendTitle--GpUwT {
  letter-spacing: -.01em;
  white-space: nowrap;
  line-height: 1.15em;
}

.StatLegend--LegendPattern--VzkoC {
  height: 2px;
  width: 100%;
}

.StatLegend--tooltipIcon--CgKc2 {
  position: relative;
  top: -0.15em;
}

.StatLegend--tooltipIcon--CgKc2 > img {
  width: 0.9em;
}

.StatLegend--LegendTooltipWrapper--I7B5q {
  z-index: 1;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/stat/StatLegend.css"],"names":[],"mappings":"AAAA;EAEE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".StatLegend {\n  composes: smallSize from '../../../styles/typography.css';\n  list-style: none;\n  display: flex;\n  margin: 0;\n  padding: 0;\n}\n\n.StatLegendItemWrapper {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin: 0 1em 0 0;\n  gap: .2em;\n}\n\n.StatLegendItem {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.StatLegendTitle {\n  letter-spacing: -.01em;\n  white-space: nowrap;\n  line-height: 1.15em;\n}\n\n.LegendPattern {\n  height: 2px;\n  width: 100%;\n}\n\n.tooltipIcon {\n  position: relative;\n  top: -0.15em;\n}\n\n.tooltipIcon > img {\n  width: 0.9em;\n}\n\n.LegendTooltipWrapper {\n  z-index: 1;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"StatLegend": `StatLegend--StatLegend--AEcS9 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"StatLegendItemWrapper": `StatLegend--StatLegendItemWrapper--EFDg1`,
	"StatLegendItem": `StatLegend--StatLegendItem--vpFW6`,
	"StatLegendTitle": `StatLegend--StatLegendTitle--GpUwT`,
	"LegendPattern": `StatLegend--LegendPattern--VzkoC`,
	"tooltipIcon": `StatLegend--tooltipIcon--CgKc2`,
	"LegendTooltipWrapper": `StatLegend--LegendTooltipWrapper--I7B5q`
};
export default ___CSS_LOADER_EXPORT___;
